import {Subject} from 'rxjs';

export class DocumentPreview {
    public frontSideFileId: string;
    public backSideFileId: string;

    public frontSideSubject: Subject<string>;
    public backSideSubject: Subject<string>;

    constructor(frontSideFileId: string, backSideFileId: string = null) {
        this.frontSideFileId = frontSideFileId;
        this.backSideFileId = backSideFileId;

        this.frontSideSubject = new Subject();
        this.backSideSubject = new Subject();
    }

    triggerFrontSidePreview(): void {
        this.frontSideSubject.next(this.frontSideFileId);
    }

    triggerBackSidePreview(): void {
        this.backSideSubject.next(this.backSideFileId);
    }

    getDocumentFileIds(): string[] {
        return [this.frontSideFileId, this.backSideFileId].filter((id: string) => [null, ''].indexOf(id) < 0);
    }
}
